import * as THREE from 'three';
import {frontierTownView} from './frontierTownView';
import {civicFrame,type PlacedCivic} from '../../../../shared/src/worldgen/civics';
import type {CityGraph} from '../../../../shared/src/worldgen/citygraph';
/** Identical asset geometry in the town lab, tier lab and streamed game. */
export function civicBuildingsView(g:CityGraph,radius:number,buildings:PlacedCivic[]){
 const group=new THREE.Group();group.name='settlement-civics';
 for(const b of buildings){
  const view=frontierTownView({seed:b.id,promenade:[],places:[{id:b.kind,plan:b.plan,position:[0,0,0],quarterTurn:0}]}),f=civicFrame(g,radius,b);
  const w=new THREE.Vector3().fromArray(f.width),up=new THREE.Vector3().fromArray(f.up),d=new THREE.Vector3().crossVectors(w,up).normalize();
  view.group.name=b.plan.asset.name;view.group.quaternion.setFromRotationMatrix(new THREE.Matrix4().makeBasis(w,up,d));view.group.position.fromArray(f.center);group.add(view.group);
 }
 return group;
}
